import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Typography } from 'components/atoms';
import { AttendanceTrackingAccessProvider } from 'contexts/AttendanceTrackingAccessContext';
import { agent } from 'services/service';
import { AttendanceUploadAccess } from 'services/AttendanceTrackingService';
import { useAppSelector } from 'store';

export const ProtectedRouteAttendanceTracking = () => {
  const token = useAppSelector((state) => state.auth?.user?.authData?.token);
  const [access, setAccess] = useState<AttendanceUploadAccess | null>(null);

  useEffect(() => {
    if (!token) return;

    agent.AttendanceTrackingService.getMyUploadAccess()
      .then((response) => setAccess(response.data))
      .catch(() =>
        setAccess({
          canUpload: false,
          canManageSettings: false,
          isAdmin: false,
          isAssignedUploader: false
        })
      );
  }, [token]);

  if (!token) return <Navigate to="/login" replace />;

  if (access === null) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <Typography type="base_medium" text="Loading attendance module..." />
      </div>
    );
  }

  if (!access.isAdmin && !access.canUpload) {
    return <Navigate to="/" replace />;
  }

  return (
    <AttendanceTrackingAccessProvider access={access}>
      <Outlet />
    </AttendanceTrackingAccessProvider>
  );
};
